import React, { useState, useEffect } from 'react';
import '../App.css';

const calculateTimeLeft = (targetDate) => {
    const difference = +targetDate - +new Date();
    if (difference > 0) {
        return {
            días: Math.floor(difference / (1000 * 60 * 60 * 24)),
            horas: Math.floor((difference / (1000 * 60 * 60)) % 24),
            min: Math.floor((difference / 1000 / 60) % 60),
            seg: Math.floor((difference / 1000) % 60),
        };
    }
    return null;
};

const Countdown = ({ targetDate, t, winner, team, results, resultsTitle }) => {
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(targetDate));

    useEffect(() => {
        setTimeLeft(calculateTimeLeft(targetDate));
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft(targetDate));
        }, 1000);
        return () => clearInterval(timer);
    }, [targetDate]);

    if (!timeLeft) {
        if (results && results.length > 0) {
            const top3 = results.slice(0, 3);
            return (
                <div className="top3-results-container">
                    <h4 className="top3-title">{resultsTitle || t.raceResults}</h4>
                    <div className="top3-list">
                        {top3.map((driverResult, index) => {
                            const badgeClass = index === 0 ? 'gold' : index === 1 ? 'silver' : 'bronze';
                            return (
                                <div key={driverResult.driver} className={`top3-item position-${index + 1}`}>
                                    <span className={`top3-position-badge ${badgeClass}`}>
                                        {index + 1}
                                    </span>
                                    <span className="top3-flag">{driverResult.flag}</span>
                                    <div className="top3-details">
                                        <span className="top3-name">
                                            {driverResult.driver}
                                            {driverResult.points !== null && driverResult.points !== undefined && (
                                                <span className="top3-points">
                                                    ({driverResult.points} {t.points})
                                                </span>
                                            )}
                                        </span>
                                        <span className="top3-team">{driverResult.team}</span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            );
        }
        return <div className="race-finished">{t.raceFinished}</div>;
    }

    const timeLabels = {
        días: t.days,
        horas: t.hours,
        min: t.minutes,
        seg: t.seconds
    };

    return (
        <>
            <div className="countdown-container">
                {Object.keys(timeLeft).map((interval) => (
                    <div key={interval} className="countdown-box">
                        <span className="countdown-number">{timeLeft[interval]}</span>
                        <span className="countdown-label">{timeLabels[interval]}</span>
                    </div>
                ))}
            </div>
            {winner && team && (
                <div className="last-winner-info">
                    <span className="last-winner-label">{t.lastWinner}:</span>
                    <span className="last-winner-name">{winner}</span>
                    <span className="last-winner-team">({team})</span>
                </div>
            )}
        </>
    );
};

export default Countdown;
